export default __webpack_public_path__ + "static/media/Q11_3_resized.016e0dad.jpg";